export const CLOUD_WIDTH = 80;
export const CLOUD_HEIGHT = 80;
export const CLOUD_PING_COUNT = 3;
export const CLOUD_PING_CYCLE = 4.8;

/** The mascot's cloud, as one closed path on an 80×80 box. */
export const CLOUD_PATH = "M16 60a15 15 0 0 1 1.7-29.7 20.5 20.5 0 0 1 38.6-3.7A15 15 0 0 1 72 60Z";
